// Shared Brazilian-locale, adaptive-unit number formatters (km²→m², GW→...→W, GWh→...→Wh).
// Mirrors the formatting used in StatisticsPanel/ProjecaoCustomizada so values built from raw
// API numbers (e.g. ProjectionAreaStatsResponse) render identically to backend-formatted cards.

const fmtBr = (value: number, decimals: number) =>
  value.toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export const fmtArea = (km2: number): string => {
  if (km2 >= 1_000_000) return `${fmtBr(km2 / 1_000_000, 2)} Mkm²`;
  if (km2 >= 1_000) return `${fmtBr(km2 / 1_000, 2)} × 10³ km²`;
  if (km2 >= 1) return `${fmtBr(km2, 2)} km²`;
  return `${fmtBr(km2 * 1_000_000, 0)} m²`;
};

export const fmtPower = (gw: number): string => {
  if (gw >= 1_000) return `${fmtBr(gw / 1_000, 2)} TW`;
  if (gw >= 1) return `${fmtBr(gw, 2)} GW`;
  const mw = gw * 1_000;
  if (mw >= 1) return `${fmtBr(mw, 1)} MW`;
  const kw = mw * 1_000;
  if (kw >= 1) return `${fmtBr(kw, 1)} kW`;
  return `${fmtBr(kw * 1_000, 0)} W`;
};

export const fmtEnergy = (gwh: number): string => {
  if (gwh >= 1_000_000) return `${fmtBr(gwh / 1_000_000, 2)} PWh`;
  if (gwh >= 1_000) return `${fmtBr(gwh / 1_000, 2)} TWh`;
  if (gwh >= 1) return `${fmtBr(gwh, 1)} GWh`;
  const mwh = gwh * 1_000;
  if (mwh >= 1) return `${fmtBr(mwh, 1)} MWh`;
  const kwh = mwh * 1_000;
  if (kwh >= 1) return `${fmtBr(kwh, 1)} kWh`;
  return `${fmtBr(kwh * 1_000, 0)} Wh`;
};
